'use client'
import { useTranslations } from 'next-intl'
import { formatNumberToNumericalAbreviation } from 'utils/number'

export function ViewSection({ viewsCount }: { viewsCount: number }) {
  const t = useTranslations('pages.clubhouse.discussions')

  return (
    <p className="text-12 text-cf-grey-600">
      {formatNumberToNumericalAbreviation(viewsCount)} {t('views')}
    </p>
  )
}
